import React from "react";
import {Link, NavLink, useNavigate} from "react-router-dom";
import "../styles/workspace.css";

/** The broker workspace's own header (the buyer site's header doesn't know about broker sessions). */
const BrokerTopBar = ({broker, onLogout}) => {
    const navigate = useNavigate();
    const isBuilder = broker?.accountType === "BUILDER";
    const approved = broker?.status === "APPROVED";
    return (
        <header className="brk-topbar">
            <Link to="/" className="brk-topbar__brand" aria-label="One Global Marketplace home">
                <img src="/logo.png" alt="" className="brk-topbar__logo"/>
                <span className="brk-topbar__product">Partner workspace</span>
            </Link>
            <nav className="brk-topbar__nav" aria-label="Workspace">
                <NavLink to="/broker/dashboard" end className="brk-topbar__link">Dashboard</NavLink>
                {approved && <NavLink to="/broker/listings/new" className="brk-topbar__link">+ Listing</NavLink>}
                {approved && isBuilder && <NavLink to="/broker/projects/new" className="brk-topbar__link">+ Project</NavLink>}
            </nav>
            {broker && (
                <div className="brk-topbar__account">
                    <div className="brk-topbar__who">
                        <span className="brk-topbar__name">{broker.companyName || broker.fullName}</span>
                        <span className="brk-topbar__role">{isBuilder ? "Builder / Developer" : "Agent / Broker"}</span>
                    </div>
                    <button type="button" className="brk-btn brk-btn--ghost brk-btn--sm"
                            onClick={() => { onLogout(); navigate("/broker/login"); }}>
                        Log out
                    </button>
                </div>
            )}
        </header>
    );
};

export default BrokerTopBar;
